import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('FarcanaProfile').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    width: '100%',

    alignItems: 'center',
    overflowX: 'hidden',
    overflowY: 'scroll',
    position: 'relative',
    paddingBottom: '27vh',
  },

  headerContainer: {
    width: '100%',
    height: '200px',
    background: theme.colors.background.secondary,
  },

  bannerContainer: {
    justifyContent: 'center',
    position: 'relative',
    minHeight: '200px',
    maxHeight: '200px',
    backgroundImage: 'url(/assets/backgrounds/farcanaProfileBanner.webp)',
    backgroundSize: '120%',
    backgroundPosition: 'center',
    backgroundPositionY: '0px',
    width: '100%',
  },

  bannerImg: {
    width: '100%',
    height: '200px',
    filter: 'brightness(65%)',
  },

  connectedText: {
    zIndex: 2,
    color: theme.colors.text.success,
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: '350',
    lineHeight: '18px',
    letterSpacing: '-0.13px',
    position: 'absolute',
    bottom: '20px',
    width: '100%',
  },

  contentWrapper: {
    width: '94%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  statsList: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(4, auto)',
    gap: '16px',
  },
  buttonsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  button: {
    height: '52px',
  },
}))
